export const languages = {
  en: 'en',
  de: 'de',
  fr: 'fr',
  nl: 'nl'
};

export const locales = {
  enGB: 'en-GB',
  deDE: 'de-DE',
  frFR: 'fr-FR',
  nlNL: 'nl-NL'
};
